/* eslint-disable import/prefer-default-export */
import axiosInstance from '../axios.instance';

export const getUserStatisticApi = (token) => axiosInstance.get('/user/statistics', {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getAboutUsersApi = (token, name) => {
  if (name) {
    return axiosInstance.get(`/user/profile/${name}`);
  }
  return axiosInstance.get('/user/profile', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setAboutUsersApi = (token, data) => axiosInstance.post('/user/store', data, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
